import { useTranslation } from 'react-i18next';
import Lottie from 'react-lottie';
import Heading from '@/components/Heading/Heading';
import LoadingAnimation from '@/assets/lottie/loading-vertical-lines.json';
import styles from './LoadingScreen.module.scss';
import H1 from '@/components/H/H1';

type Props = {
  title?: string;
  subTitle?: string;
};

const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: LoadingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
export default function LoadingScreen({ title, subTitle }: Props) {
  const { t } = useTranslation('loading_screen');

  return (
    <div className={styles.wrapper} data-test="loadingScreen">
      <div className={styles.lottie} data-test="loadingScreen-lottie-wrapper">
        <Lottie width={200} options={lottieOptions} />
      </div>
      <H1 className={styles.title} dataTest="loadingScreen-title">
        {title || t('title')}
      </H1>
      <Heading
        className={styles.subtitle}
        size="s"
        dataTest="loadingScreen-subtitle"
      >
        {subTitle || t('subtitle')}
      </Heading>
    </div>
  );
}
